import {doc, getDoc, updateDoc} from "firebase/firestore";
import {toast} from "react-toastify";
import {db} from "../../config/firebase";
import {PROJECTS_COLLECTION} from "../../db/collections";

// Every sub project has a Firebase flow (flowUid). The flow runtime and the pages that are not rebuilt
// yet still read it, so changes saved through the Project API are mirrored there.
const flowRef = (subProject) => doc(db, PROJECTS_COLLECTION, subProject.flowUid);

export const getFlow = async (subProject) => (await getDoc(flowRef(subProject))).data() || null;

// fields is a Firestore update map, dotted keys update nested fields (e.g. "settings.organization")
export const updateFlow = (subProject, fields) =>
  updateDoc(flowRef(subProject), {...fields, updatedAt: new Date().getTime()});

// Runs `mirror` for every sub project. The API change is already saved at this point, so a failure
// is reported without failing the save.
export const mirrorToFlows = async (subProjects, mirror) => {
  try {
    await Promise.all(subProjects.filter(item => item.flowUid).map(mirror));
  } catch (e) {
    console.error(e);
    toast.warn("Saved, but the project's flows could not be updated");
  }
};
